<template>
    <router-view></router-view>
  </template>
  
  <script>
  import LoginCheck from "@/mixins/LoginCheck";
  export default {
    mixins: [LoginCheck]
  };
  </script>
  